import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { SetupImplementService } from '../setup-implement.service';
import { GenericIdName, saveNewImplementTypeVM } from '../setup-implement.model';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-add-new-componentType',
  templateUrl: './add-new-componentType.component.html',
  styleUrls: ['./add-new-componentType.component.css']
})
export class SelectionNewImplementComponent implements OnInit {
  savingChanges: boolean = false;
  compType: string;
  isImpType: boolean = false;
  isImplement: boolean = false;
  isCompType: boolean = false;
  implementSerial: string;
  NewimplementType: string;
  ImplementId: number
  constructor(public dialogRef: MatDialogRef<SelectionNewImplementComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, public _implementService: SetupImplementService,
    public toastr: NotificationsService, vcr: ViewContainerRef,) { }


  ngOnInit() {

    this.isImpType = this.data.isImpType

    this.isCompType = this.data.isCompType
    this.isImplement = this.data.isImplement
    this.implementSerial = this.data.implementSerial;
    this.ImplementId = this.data.ImplementId;
    // if(this.data.ImplementId == null || this.data.ImplementId == undefined)
    // {
    //   this.isImpType = true;
    // }else{
    //   this.isImpType=false;
    // }

  }

  onCloseClick(): void {
    this.dialogRef.close(false);
  }

  saveChanges(): void {
    if (this.savingChanges) {
      return;
    }
    else {
      if (this.isCompType == true) {
        var params = new GenericIdName();
        params.Id = this.data.ImplementId;
        params.Name = this.compType;
        this._implementService.SaveComponentType(params).subscribe(response => {
          if (response == false) {
            this.toastr.error("Component Type exist for this implement");
            this.savingChanges = false;
          }
          else {
            this.dialogRef.close(true);
          }
        }, error => { console.log(error); });
      }
      else if (this.isImpType == true) {
        // save implement type

        var params1: saveNewImplementTypeVM = new saveNewImplementTypeVM();
        params1.customerId = this.data.selectedCustomer;
        params1.NewimplementType = this.NewimplementType;

        this._implementService.SaveImplementType(params1).subscribe(res => {
          if (res < 0) {
            this.toastr.error("Implement Type is already exists");
            this.savingChanges = false;
          }
          else {
            this.dialogRef.close(true);
          }
        })
      }
      else if (this.isImplement == true) {
        // save implement serial

        var params = new GenericIdName();
        params.Id = this.ImplementId;
        params.Name = this.implementSerial;
        //check validation 
        this._implementService.ValidateImplementSerial(this.ImplementId, this.implementSerial).subscribe(r => {
          if (!r) {
            this.toastr.error("That serial number is unavailable. Please enter a different one.");
            this.implementSerial = this.data.implementSerial;
          } else {
            this._implementService.EditImplementSerial(params).subscribe(res => {
              if (res == true) {
                this.dialogRef.close(this.implementSerial);
                this.toastr.success("Implement Updated successfully");

              }
            })
          }
        });


      }

    }
  }
}
